const newLineRegex = /(\r\n|\r|\n)/g;

export const convertLinebreaksToBr = string =>
  string.replace(newLineRegex, '<br/>');
export const convertLinebreaksToControlledBrs = (string, numberOfBreaks = 1) =>
  string.replace(
    newLineRegex,
    [...Array(numberOfBreaks).keys()].map(() => '<br/>').join(''),
  );
